export const MATCH_REPORT_COPY = {
  intro: {
    fr: {
      title: "Photographie de jeu",
      text:
        "Ce Match Report est une photographie fidèle de ton jeu à cet instant précis. " +
        "Il ne cherche pas à te juger, mais à mettre en lumière ce qui est déjà solide " +
        "et ce qui mérite ton attention en priorité pour progresser plus vite, " +
        "sans perdre de temps ni d’énergie.",
    },
    en: {
      title: "Playing snapshot",
      text:
        "This Match Report is an accurate snapshot of your playing at this exact moment. " +
        "It is not meant to judge you, but to highlight what is already solid " +
        "and what deserves your focus to progress faster, " +
        "without wasting time or energy.",
    },
  },

  priorities: {
    fr: {
      title: "Priorités de travail",
      text:
        "Ces points ont été sélectionnés car ils ont l’impact le plus direct " +
        "sur ta progression actuelle.",
    },
    en: {
      title: "Practice priorities",
      text:
        "These points were selected because they have the strongest impact " +
        "on your current progress.",
    },
  },

  reliabilityNotice: {
    fr:
      "L’absence de conseil sur certains modules est volontaire : " +
      "Guitar Match&Play n’affiche un retour que lorsqu’il repose " +
      "sur des mesures fiables et vérifiées.",
    en:
      "Missing feedback on some modules is intentional: " +
      "Guitar Match&Play only displays insights based on verified, " +
      "reliable measurements.",
  },

  tabTransition: {
    fr:
      "Chaque section ci-dessous correspond à un onglet d’analyse. " +
      "Tu peux les explorer pour comprendre plus finement chaque dimension de ton jeu.",
    en:
      "Each section below corresponds to an analysis tab. " +
      "You can explore them to dive deeper into each dimension of your playing.",
  },
} as const;
